import React from "react";
import MostAskedThemes from "./MostAskedThemes";
import "./Styling.css";
import { UsersTable } from "./UsersTable";
import Duration from "./images/duration.png";

const ThemesAndUsers = ({ data, startDate, endDate }) => {
  return (
    <div className="themes-and-users">
      <div className="most-asked-themes">
        <MostAskedThemes startDate={startDate} endDate={endDate} data={data} />
      </div>
      <div className="users-table-wrapper">
        <UsersTable
          startDate={startDate}
          endDate={endDate}
          users={data?.users}
        />
      </div>
    </div>
  );
};

export default ThemesAndUsers;
